export const WEB_LOGIN_CLICKEDSIGNIN = 'WEB_LOGIN_CLICKEDSIGNIN';
export const WEB_LOGIN_CLICKEDCREATEYOURACCOUNT =
  'WEB_LOGIN_CLICKEDCREATEYOURACCOUNT';
export const WEB_TRIALNUDGE_CLICKEDPERSONALIZEINVOICES =
  'WEB_TRIALNUDGE_CLICKEDPERSONALIZEINVOICES';
export const WEB_TRIALNUDGE_CLICKEDADDFIVEEXPENSESPERMONTH =
  'WEB_TRIALNUDGE_CLICKEDADDFIVEEXPENSESPERMONTH';
export const WEB_TRIALNUDGE_CLICKEDTAXSUBMISSION =
  'WEB_TRIALNUDGE_CLICKEDTAXSUBMISSION';
export const WEB_TRIALNUDGE_CLICKEDTAXGUARANTEE =
  'WEB_TRIALNUDGE_CLICKEDTAXGUARANTEE';
export const WEB_TRIALNUDGE_CLICKEDUPGRADENOW =
  'WEB_TRIALNUDGE_CLICKEDUPGRADENOW';
export const WEB_TRIALNUDGE_CLICKEDCOMPAREPLANS =
  'WEB_TRIALNUDGE_CLICKEDCOMPAREPLANS';
